/* eslint-disable class-methods-use-this */
import { WasteRegisterAPIM } from 'utils/__interfaces/WasteRegister/wasteRegisterAPIM'
import WasteRegisterEntity from 'utils/__interfaces/WasteRegister/WasteRegisterEntity'
import { parseDate } from 'utils/Common/date-utils'
import { normalizeString } from 'utils/Common/ts-utils'

class WasteRegisterNormalizer {
  normalize(dataList: WasteRegisterAPIM[]): WasteRegisterEntity[] {
    return dataList.map(
      ({
        idRegistreDechet,
        codeDechetNED,
        numDocumentAnnexeVII,
        nomTransporteur,
        numBSD,
        numRecipisseTransporteur,
        rueAdresseTransporteur,
        qteContaminant,
        libelleDechetNEDContaminant,
        qtePesee,
        dateExpedition,
        nomExutoire,
        rueAdresseExutoire,
        cpAdresseExutoire,
        villeAdresseExutoire,
        libelleTraitementExutoire,
        fkPointCollecte,
        fkMatiere,
        codeTraitementExutoire,
        numBonIntervention,
        volumeMateriel,
        uniteVolumeMateriel,
        cpAdresseTransporteur,
        villeAdresseTransporteur,
        numDossier,
        libelleDechetNED,
        codeDechetNEDContaminant,
        qteCollectee,
        descriptionDossier,
        unite,
        qualificationTraitementFinal,
        dechetPop,
        nomCourtier,
        numContrat,
        numNotification,
        numRecipisseCourtier,
        numSaisie,
        paysAdresseProducteur,
        paysAdresseTransporteur,
        siretCourtier,
        siretExutoire,
        siretProducteur,
        siretTransporteur,
        typeCourtier,
        typeExutoire,
        typeProducteur,
        typeTransporteur,
        numBonPesee,
      }) => ({
        idRegister: idRegistreDechet,
        nomSiteExpediteur: nomExutoire,
        nRueSiteExpediteur: rueAdresseExutoire,
        cpSiteExpediteur: cpAdresseExutoire,
        villeExpediteur: villeAdresseExutoire,
        numDossier,
        descriptionDossier: normalizeString(descriptionDossier),
        numBonIntervention: normalizeString(numBonIntervention),
        dateExpedition: parseDate(dateExpedition),
        codeDechetNED,
        nbInstitutions: 11,
        natureDechet: normalizeString(libelleDechetNED),
        quantitePesee: qtePesee != null ? qtePesee : 0,
        unite,
        quantiteCollectee: qteCollectee != null ? qteCollectee : 0,
        uniteVolume: '',
        nomInstallation: normalizeString(fkPointCollecte?.nomPointCollecte),
        nRueInstallation: normalizeString(fkPointCollecte?.ruePointCollecte),
        villeInstallation: normalizeString(fkPointCollecte?.villePointCollecte),
        codePostalAdresseInstallation: normalizeString(
          fkPointCollecte?.codePostalPointCollecte
        ),
        nomTransporteur,
        nRueTransporteur: rueAdresseTransporteur,
        cpAdresseTransporteur,
        villeAdresseTransporteur,
        numeroRecepisseTransporteur: numRecipisseTransporteur,
        nBSD: normalizeString(numBSD),
        nDocAnnexe: normalizeString(numDocumentAnnexeVII),
        codeTraitement: codeTraitementExutoire,
        libelleTraitement: libelleTraitementExutoire,
        qualificationTraitement: normalizeString(qualificationTraitementFinal),
        volumeMateriel: Number(normalizeString(volumeMateriel)),
        uniteVolumeMateriel: normalizeString(uniteVolumeMateriel),
        codeDechetNEDContaminant: normalizeString(codeDechetNEDContaminant),
        libelleDechetNEDContaminant: normalizeString(
          libelleDechetNEDContaminant
        ),
        qteContaminant: qteContaminant !== null ? qteContaminant : 0,
        dechetPop: normalizeString(dechetPop),
        nomCourtier: normalizeString(nomCourtier),
        numContrat: normalizeString(numContrat),
        numNotification: normalizeString(numNotification),
        numRecipisseCourtier: normalizeString(numRecipisseCourtier),
        numSaisie: normalizeString(numSaisie),
        paysAdresseProducteur: normalizeString(paysAdresseProducteur),
        paysAdresseTransporteur: normalizeString(paysAdresseTransporteur),
        siretCourtier: normalizeString(siretCourtier),
        siretExutoire: normalizeString(siretExutoire),
        siretProducteur: normalizeString(siretProducteur),
        siretTransporteur: normalizeString(siretTransporteur),
        typeCourtier: normalizeString(typeCourtier),
        typeExutoire: normalizeString(typeExutoire),
        typeProducteur: normalizeString(typeProducteur),
        typeTransporteur: normalizeString(typeTransporteur),
        numBonPesee: normalizeString(numBonPesee),
        matiere: normalizeString(fkMatiere?.libelleDechetInterne),
      })
    )
  }
}

export default new WasteRegisterNormalizer()
